var exports = {
  "vj": "tabNav__U5aH7j",
  "gj": "tabList__01lxw9",
  "HX": "tabNavLink__QZ_sO4",
  "wH": "selected__qtyLML",
};

module.exports = exports;
